import { Routes, Route } from 'react-router-dom'

import HEHMOptions from 'pages/paywall/HEHMOptions'
import HEHMAccount from 'pages/paywall/HEHMAccount'
import PaywallStatements from 'pages/paywall/PaywallStatements'
import DeprovisionedHehmDevices from 'pages/DeprovisionedHehmDevices'

const HEHMRouter = () => {
  return (
    <Routes>
      <Route path={'options/:dealerId'} element={<HEHMOptions />} />
      <Route path={'account/:dealerId/:planNo/:planType'} element={<HEHMAccount />} />
      <Route path={'statements/:dealerId'} element={<PaywallStatements paywallType={'hehm'} />} />
      <Route path={'deprovisioned/:dealerId'} element={<DeprovisionedHehmDevices />} />
    </Routes>
  )
}

export default HEHMRouter
